import { render, staticRenderFns } from "./AtmoInfoIaqi.vue?vue&type=template&id=92444ca4&scoped=true&"
import script from "./AtmoInfoIaqi.vue?vue&type=script&lang=ts&"
export * from "./AtmoInfoIaqi.vue?vue&type=script&lang=ts&"
import style0 from "./AtmoInfoIaqi.vue?vue&type=style&index=0&id=92444ca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92444ca4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92444ca4')) {
      api.createRecord('92444ca4', component.options)
    } else {
      api.reload('92444ca4', component.options)
    }
    module.hot.accept("./AtmoInfoIaqi.vue?vue&type=template&id=92444ca4&scoped=true&", function () {
      api.rerender('92444ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/integrations/templates/AtmoInfoIaqi.vue"
export default component.exports